import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormSelect } from "src/app/components/form/SimpleFormSelect";
import useWritersOptions from "src/app/hooks/useWritersOptions/useWritersOptions";
import { OrderTransport } from "src/app/transports/order";
import { object, number } from "yup";

export interface IAddWritersToOrderContainer {
    selectedRows: any[];
    handlerValueToUpdateGrid(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
const AddWritersToOrderContainer = (props: IAddWritersToOrderContainer) => {
    const { selectedRows, handlerValueToUpdateGrid, handleClose, showModal } = props;
    const { formatMessage } = useIntl();
    const { writersOptions, loading: writerOptionsLoading } = useWritersOptions();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (_values: { writerId: number | undefined }) => {
        setLoading(true);

        if (!_values.writerId) {
            setLoading(false);
            toast.error(formatMessage({ id: "common.notification.error" }));
            return;
        }

        try {
            await OrderTransport.addWriters(
                selectedRows.map((el) => el.id),
                _values.writerId
            );
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName="Writer"
            showModal={showModal}
            handleClose={handleClose}
            formId="addWriter"
            loading={loading}
            modalProps={{ size: "sm" }}
        >
            <Formik
                initialValues={{ writerId: undefined }}
                validationSchema={object().shape({
                    writerId: number().required(),
                })}
                onSubmit={onSubmit}
            >
                <Form id="addWriter">
                    <SimpleFormSelect
                        isLoading={writerOptionsLoading}
                        name="writerId"
                        label="writer"
                        values={writersOptions}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default AddWritersToOrderContainer;
